import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../../../admin-core/services';
import { QuoteOrderSampleService } from '../../../../admin-core/apiservices/quote-order-sample.service';
import { Constants } from '../../../../admin-core/constants';
import {FormAutofocusDirective} from '../../../../shared/directives/form-autofocus.directive';

@Component({
  hostDirectives: [FormAutofocusDirective],
  standalone: false,
    selector: 'app-update-sample-product-notes-modal',
    // Eager: Angular 22 defaults every component to OnPush, which would leave this view
    // unpainted after its subscribe callbacks (see app.component.ts for the full note).
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './update-sample-product-notes-modal.component.html',
    styleUrls: ['./update-sample-product-notes-modal.component.css', '../../../../app.component.css'],
})
export class UpdateSampleProductNotesModalComponent implements OnInit {
    @Input() productsRow: any;
    @Input() loginUserId: any;

    productName = '';
    notes = '';
    isLoading = false;

    constructor(
        public activeModal: NgbActiveModal,
        private orderService: QuoteOrderSampleService,
        private alertService: AlertService,
    ) {}

    ngOnInit() {
        // Show the family name with the SKU code in brackets, e.g.
        // "WOLFDEN (7PA222*/3-2_SAMPLE)". Fall back gracefully when either is missing.
        const sampleProduct = this.productsRow?.product?.sample_product;
        const familyName = sampleProduct?.family?.name || '';
        const sku = sampleProduct?.sku || '';
        this.productName = sku ? `${familyName} (${sku})`.trim() : familyName;
        this.notes = sampleProduct?.sample_product_description?.short_description || '';
    }

    cancel() {
        this.activeModal.close(false);
    }

    onSubmit() {
        const sampleId = this.productsRow?.product?.sample_product?.id;
        if (!sampleId) {
            this.alertService.error('Couldn’t identify the sample product.');
            return;
        }

        this.isLoading = true;
        this.orderService.updateSampleProductDescription(sampleId, {
            short_description: this.notes,
            updated_by: this.loginUserId,
        }).subscribe({
            next: () => {
                this.isLoading = false;
                this.alertService.success(Constants.SAMPLE_REQUEST_MESSAGE_CONSTANTS.SAMPLE_PRODUCT_NOTES_UPDATE);
                this.activeModal.close({ short_description: this.notes });
            },
            error: (err: any) => {
                this.isLoading = false;
                if (err?.message) {
                    this.alertService.error(err.message);
                }
            },
        });
    }
}
